import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	ADD_CUSTOMER,
	ADD_PROVIDER,
	DELETE_USER,
	EDIT_CUSTOMER,
	EDIT_PROVIDER,
	EDIT_REQUEST,
	GET_CUSTOMERS, 
	GET_FACULTIES, 
	GET_LANGUAGES, 
	GET_PAYMENT_METHODS, 
	GET_PROVIDERS, 
	GET_REQUEST_TRANSLATION, 
	GET_ROLES
} from '../constants/Request';
import {
	getFacultiesSuccess,
	getFacultiesError,
	getLanguagesSuccess,
	getLanguagesError,
	getPaymentMethodsSuccess,
	getPaymentMethodsError,
	getProvidersSuccess,
	getProvidersError,
	getCustomersSuccess,
	getCustomersError,
	getRolesSuccess,
	getRolesError,
	editRequestSuccess,
	editRequestError,
	deleteUserSuccess,
	deleteUserError,
	editCustomerError,
	editCustomerSuccess,
	addCustomerError,
	addCustomerSuccess,
	editProviderError,
	editProviderSuccess,
	addProviderError,
	addProviderSuccess,
	getRequestTranslationError,
	getRequestTranslationSuccess
} from "../actions/Request";

import {
	deleteProviderService,
	deleteCustomerService,
	editRequestService,
	getCustomersService,
	getFacultiesService,
	getLanguagesService,
	getPaymentMethodsService,
	getProvidersService,
	getRolesService,
	editCustomerService,
	addCustomerService,
	editProviderService,
	addProviderService,
	getRequestTranslationService
} from 'redux/services/Request';

export function* getRequestTranslationSaga() {
	yield takeEvery(GET_REQUEST_TRANSLATION, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getRequestTranslationService, query);
			if (data.message) {
				yield put(getRequestTranslationError(data.message));
			} else {
				yield put(getRequestTranslationSuccess(data));
			}
		} catch (err) {
			yield put(getRequestTranslationError(err));
		}
	});
}

export function* getFacultiesSaga() {
	yield takeEvery(GET_FACULTIES, function* ({ payload }) {
		try {
			const data = yield call(getFacultiesService);
			if (data.message) {
				yield put(getFacultiesError(data.message));
			} else {
				let specialities = [], faculties = [], universities = [];
				for (let item of data) {
					universities.push(item.university);
					faculties.push(item);
					for (let elem of item.specialities) {
						specialities.push(elem);
					}
				}
				yield put(getFacultiesSuccess(specialities, faculties, universities));
			}
		} catch (err) {
			yield put(getFacultiesError(err));
		}
	});
}

export function* getLanguagesSaga() {
	yield takeEvery(GET_LANGUAGES, function* ({ payload }) {
		try {
			const data = yield call(getLanguagesService);
			if (data.message) {
				yield put(getLanguagesError(data.message));
			} else {
				yield put(getLanguagesSuccess(data));
			}
		} catch (err) {
			yield put(getLanguagesError(err));
		}
	});
}

export function* getPaymentMethodsSaga() {
	yield takeEvery(GET_PAYMENT_METHODS, function* ({ payload }) {
		try {
			const data = yield call(getPaymentMethodsService);
			if (data.message) {
				yield put(getPaymentMethodsError(data.message));
			} else {
				yield put(getPaymentMethodsSuccess(data));
			}
		} catch (err) {
			yield put(getPaymentMethodsError(err));
		}
	});
}

export function* getProvidersSaga() {
	yield takeEvery(GET_PROVIDERS, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getProvidersService, query);
			if (data.message) {
				yield put(getProvidersError(data.message));
			} else {
				yield put(getProvidersSuccess(data.data));
			}
		} catch (err) {
			yield put(getProvidersError(err));
		}
	});
}

export function* getCustomersSaga() {
	yield takeEvery(GET_CUSTOMERS, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getCustomersService, query);
			if (data.message) {
				yield put(getCustomersError(data.message));
			} else {
				yield put(getCustomersSuccess(data.data));
			}
		} catch (err) {
			yield put(getCustomersError(err));
		}
	});
}

export function* getRolesSaga() {
	yield takeEvery(GET_ROLES, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getRolesService, query);
			if (data.message) {
				yield put(getRolesError(data.message));
			} else {
				yield put(getRolesSuccess(data));
			}
		} catch (err) {
			yield put(getRolesError(err));
		}
	});
}

export function* editRequestSaga() {
	yield takeEvery(EDIT_REQUEST, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editRequestService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editRequestError(result.message));
			} else {
				yield call(cb, { message: 'Request saved', type: 'success' });
				yield put(editRequestSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editRequestError(err));
		}
	});
}

export function* deleteUserSaga() {
	yield takeEvery(DELETE_USER, function* ({ payload }) {
		const { id, type, cb } = payload;
		try {
			let result;
			if (type === 'customer') result = yield call(deleteCustomerService, id);
			else result = yield call(deleteProviderService, id);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(deleteUserError(result.message));
			} else {
				if (type === 'customer') yield call(cb, { message: 'Customer deleted', type: 'success' });
				else yield call(cb, { message: 'Provider deleted', type: 'success' });
				yield put(deleteUserSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(deleteUserError(err));
		}
	});
}

export function* editCustomerSaga() {
	yield takeEvery(EDIT_CUSTOMER, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editCustomerService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editCustomerError(result.message));
			} else {
				yield call(cb, { message: 'Customer saved', type: 'success' });
				yield put(editCustomerSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editCustomerError(err));
		}
	});
}

export function* addCustomerSaga() {
	yield takeEvery(ADD_CUSTOMER, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addCustomerService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addCustomerError(result.message));
			} else {
				yield call(cb, { message: 'Customer saved', type: 'success' });
				yield put(addCustomerSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addCustomerError(err));
		}
	});
}

export function* editProviderSaga() {
	yield takeEvery(EDIT_PROVIDER, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editProviderService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editProviderError(result.message));
			} else {
				yield call(cb, { message: 'Provider saved', type: 'success' });
				yield put(editProviderSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editProviderError(err));
		}
	});
}

export function* addProviderSaga() {
	yield takeEvery(ADD_PROVIDER, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addProviderService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addProviderError(result.message));
			} else {
				yield call(cb, { message: 'Provider saved', type: 'success' });
				yield put(addProviderSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addProviderError(err));
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getRequestTranslationSaga),
		fork(getFacultiesSaga),
		fork(getLanguagesSaga),
		fork(getPaymentMethodsSaga),
		fork(getProvidersSaga),
		fork(getCustomersSaga),
		fork(getRolesSaga),
		fork(editRequestSaga),
		fork(deleteUserSaga),
		fork(editCustomerSaga),
		fork(addCustomerSaga),
		fork(editProviderSaga),
		fork(addProviderSaga)
	]);
}
